import AdminFunds from './container';

export default AdminFunds;
